<template>
    <div id="careers">
        <div class="main d-flex align-items-center">
            <div class="container">
                <h1 class="mb-4 py-4 text-center">{{ eng ? 'Careers' : 'Empleos' }}</h1>

                <div class="">
                    <label>{{ lang.fullName }}</label>
                    <input class="form-control mb-2"
                           type="text"
                           v-model="name"
                           :class="{'is-invalid': submitted && !name}"
                           :placeholder="lang.fullName">

                    <label>{{ lang.phone }}</label>
                    <input class="form-control mb-2"
                           v-model="homePhone"
                           type="text"
                           :class="{'is-invalid': submitted && !homePhone}"
                           :placeholder="lang.phone">

                    <div class="d-flex no-gutters">
                        <div class="col-md-6 pr-2">
                            <label>{{ lang.email }}</label>
                            <input class="form-control mb-2"
                                   type="email"
                                   v-model="email"
                                   :placeholder="lang.email">
                        </div>

                        <div class="col-md-6">
                            <label>{{ lang.dob }}</label>
                            <input class="form-control mb-2"
                                   type="date"
                                   v-model="birthday"
                                   :placeholder="lang.dob">
                        </div>
                    </div>

                    <label>{{ lang.address }}</label>
                    <input class="form-control mb-2"
                           type="text"
                           v-model="address"
                           :placeholder="lang.address">

                    <label>{{ lang.experience }}</label>
                    <textarea class="form-control mb-4"
                              v-model="experience"
                              :placeholder="lang.experience"></textarea>
                </div>

                <button class="btn bg-dark-blue text-white btn-block"
                        @click="submitForm">{{ lang.submit }}</button>
            </div>
        </div>
    </div>
</template>

<script>
  import qs from 'qs'
  import text from './language.json'

  export default {
    name: 'Careers',

    computed: {
      lang () {
        return this.eng ? this.text.en : this.text.sp
      },

      submitEnabled () {
        return this.name && this.homePhone
      }
    },

    data () {
      return {
        address: '',
        birthday: '',
        email: '',
        experience: '',
        homePhone: '',
        name: '',
        submitted: false,
        text
      }
    },

    methods: {
      submitForm () {
        this.submitted = true
        if (!this.submitEnabled) return this.$swal.fire({ type: 'error', text: 'Please fill out the form and try again'})

        let data = {
          address: this.address,
          birthday: this.birthday,
          email: this.email,
          experience: this.experience,
          name: this.name,
          homePhone: this.homePhone
        }

        this.$http.post('inc/career.php', qs.stringify(data)).then(res => {
          this.$swal.fire({ type: 'success', text: 'Application has been sent. Thank you for submitting your application. We will get in touch with you soon.'})

          this.submitted = false

          this.address = ''
          this.birthday = ''
          this.email = ''
          this.experience = ''
          this.homePhone = ''
          this.name = ''

        }).catch(err => {
          console.log('error: ', err)
          this.$swal.fire({ type: 'error', text: 'Application could not be sent. Please try again in five minutes, or give us a call.'})
        })
      }
    },

    props: ['eng']
  }
</script>

<style lang="sass" scoped>
#careers
    padding-bottom: 50px
    min-height: calc(100vh - 119px)
    background-color: rgba(255, 255, 255, 0.5)

    .main
        height: calc(100vh - 50px)

    label
        margin-bottom: 0
        font-size: 14px
        color: #777
</style>



// WEBPACK FOOTER //
// src/components/Careers.vue